import { render, staticRenderFns } from "./YoutubeFeed.vue?vue&type=template&id=280a005e&"
import script from "./YoutubeFeed.vue?vue&type=script&lang=js&"
export * from "./YoutubeFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports